<template>
  <div class="seomain">
    <ul class="tab-tilte">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <div class="keyword">
      <van-search
        v-model="search_code"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="支持订单号 , sku , 产品名称"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div>
    <div class="tab-content tab-content-list">
      <div v-show="cur == 0" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist0" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">{{ v.status_text }}</div>
            </div>
            <div class="st-list-main">
              <p>采购类型：{{ v.style }}</p>
              <p>供应商：{{ v.suppliername }}</p>
              <p>物流方：{{ v.purchasingtracking }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.shipmentnumber }}</p>
              <p>采购人：{{ v.operatorname }}</p>
              <p>预计到货时间：{{ v.deliverytime }}</p>
            </div>
            <div class="st-list-bottom-diy">
              <div class="st-diyr-btn">
                <router-link :to="'/shopping/info/' + v.id" class="st-opt-btn">查 看</router-link>
              </div>
            </div>
          </div>
        </van-list>
      </div>
			<div v-show="cur == 1" class="st-list-box pan-0">
			  <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
			    <div class="st-list" v-for="(v, k) in stlist1" :key="v.id" :index="k">
			      <div class="st-list-top">
			        <div class="t-tit">{{ v.code }}</div>
			        <div class="t-status">审核中</div>
			      </div>
			      <div class="st-list-main">
			        <p>采购类型：{{ v.style }}</p>
			        <p>供应商：{{ v.suppliername }}</p>
			        <p>物流方：{{ v.purchasingtracking }}</p>
			        <p @click="getExInfo(v.id)">物流单号：{{ v.shipmentnumber }}</p>
			        <p>采购人：{{ v.operatorname }}</p>
			        <p>预计到货时间：{{ v.deliverytime }}</p>
			      </div>
			      <div class="st-list-bottom-diy">
			        <div class="st-diyr-btn">
			          <router-link :to="'/shopping/info/' + v.id" class="st-opt-btn">查 看</router-link>
			        </div>
			      </div>
			    </div>
			  </van-list>
			</div>
      <div v-show="cur == 2" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist2" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">审核通过</div>
            </div>
            <div class="st-list-main">
              <p>采购类型：{{ v.style }}</p>
              <p>供应商：{{ v.suppliername }}</p>
              <p>采购人：{{ v.operatorname }}</p>
              <p>预计到货时间：{{ v.deliverytime }}</p>
            </div>
            <div class="st-list-bottom-diy">
              <div class="st-diyr-btn">
                <div class="st-opt-btn st-list-bottom" @click="onExCommit(v.id)">填写物流信息</div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 3" class="st-list-box pan-1">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist3" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">审批通过</div>
            </div>
            <div class="st-list-main">
              <p>采购类型：{{ v.style }}</p>
              <p>供应商：{{ v.suppliername }}</p>
              <p>物流方：{{ v.purchasingtracking }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.shipmentnumber }}</p>
              <p>采购人：{{ v.operatorname }}</p>
              <p>预计到货时间：{{ v.deliverytime }}</p>
            </div>
            <div class="st-list-bottom-diy">
              <div class="st-diyr-btn">
                <router-link :to="'/shopping/info/' + v.id" class="st-opt-btn">查 看</router-link>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 4" class="st-list-box pan-2">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist4" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">部分已入库</div>
            </div>
            <div class="st-list-main">
              <p>采购类型：{{ v.style }}</p>
              <p>供应商：{{ v.suppliername }}</p>
              <p>物流方：{{ v.purchasingtracking }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.shipmentnumber }}</p>
              <p>采购人：{{ v.operatorname }}</p>
              <p>预计到货时间：{{ v.deliverytime }}</p>
            </div>
            <div class="st-list-bottom-diy">
              <div class="st-diyr-btn">
                <router-link :to="'/shopping/info/' + v.id" class="st-opt-btn">查 看</router-link>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 5" class="st-list-box pan-2">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist5" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">已入库</div>
            </div>
            <div class="st-list-main">
              <p>采购类型：{{ v.style }}</p>
              <p>供应商：{{ v.suppliername }}</p>
              <p>物流方：{{ v.purchasingtracking }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.shipmentnumber }}</p>
              <p>采购人：{{ v.operatorname }}</p>
              <p>预计到货时间：{{ v.deliverytime }}</p>
            </div>
            <div class="st-list-bottom-diy">
              <div class="st-diyr-btn">
                <router-link :to="'/shopping/info/' + v.id" class="st-opt-btn">查 看</router-link>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <van-dialog class="exDialog" ref="exDialog" v-model="exShow" :title="exDialogTitle">
      <van-steps direction="vertical" :active="0" active-color="#fa6e09">
        <van-step v-for="(item, index) in exDataList" :key="index">
          <h3>{{ item.time }}</h3>
          <p>{{ item.step }}</p>
        </van-step>
      </van-steps>
    </van-dialog>

    <van-dialog v-model="exCommitShow" showCancelButton title="提交物流信息" @confirm="exCommit">
      <div :style="{ padding: '10px' }">
        <el-form ref="form" :model="exCommitForm" label-width="80px">
          <el-form-item label="物流方:">
            <div class="exInput" @click="onSelectEx">{{ exCommitForm.purchasingtracking }}</div>
            <!-- <el-input disabled v-model="exCommitForm.purchasingtracking" @click="onSelectEx"></el-input> -->
          </el-form-item>
          <el-form-item label="物流单号:">
            <el-input v-model="exCommitForm.logisticsnumber"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </van-dialog>

    <van-popup v-model="exPopShow" position="bottom" :style="{ height: '50%' }">
      <van-picker title="选择物流方" show-toolbar :columns="exList" @confirm="onExConfirm" @cancel="exPopShow = false"
    /></van-popup>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      tabTitle: ["全部","审核中", "审核通过", "待入库", "部分待入库", "已入库"],
      cur: 0,
      status: 0,
      stlist0: [],
      stlist1: [],
      stlist2: [],
      stlist3: [],
      stlist4: [],
      exShow: false,
      exDialogTitle: "",
      exDataList: [],
      exCommitShow: false,
      exCommitForm: {
        id: "",
        purchasingtracking: "",
        logisticsnumber: "",
      },
      exPopShow: false,
      exList: ["test1", "test2", "test3"], // 物流方列表
      order_code: "", // 关键字搜索
			search_code: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    async get_st_list(e) {
      this.stlist0 = [];
      this.stlist1 = [];
      this.stlist2 = [];
      this.stlist3 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    async init() {
      let activeIndex = window.sessionStorage.getItem("shopping_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
      }
      let result = await this.$post(this.$api.stGetExList);
      this.exList = result.data;
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("shopping_activeIndex", value);
    }, // 分页
    async onLoad() {
			this.loading = true;
      let result = await this.$post(this.$api.stGetCaigoudanList, {
        order_code: this.order_code,
        search_code: this.search_code,
        status: this.cur,
        page: this.page,
      });
      if (result.data.length == 0) return (this.finished = true);
      // 进行操作
      this["stlist" + this.cur].push(...result.data.list);
      console.log(this.stlist);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
    // 获取物流信息
    async getExInfo(id) {
      let { purchasingtracking, shipmentnumber } = this["stlist" + this.cur].filter((item) => item.id == id)[0];
      this.exDialogTitle = purchasingtracking + ": " + shipmentnumber;
      let result = await this.$post(this.$api.stGetCaigouExInfo, { id });
      if (result.data.code == 1) {
        console.log(result.data.data);
        this.exDataList = result.data.data;
      } else {
        this.exDataList = [{ step: "暂无轨迹信息,请确认订单号是否填写正确." }];
      }
      this.exShow = true;
    },
    onExCommit(id) {
      this.exCommitShow = true;
      this.exCommitForm = { id, purchasingtracking: "", logisticsnumber: "" };
    },
    onSelectEx() {
      console.log("click");
      this.exPopShow = true;
    },
    onExConfirm(value) {
      this.exCommitForm.purchasingtracking = value;
      this.exPopShow = false;
    },
    //审核通过 > 提交物流信息
    async exCommit() {
      let params = this.exCommitForm;
      if (params.logisticsnumber.trim() == "" || params.purchasingtracking == "") {
        return this.$toast.fail("物流信息不能为空");
      }
      let result = this.$post(this.$api.stGetCaigouCreatEx, params);
      this.$toast.success("添加成功");
      this.get_st_list();
    },
    onSearch(val) {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
  },
  created() {
    this.init();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "采购订单" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.keyword {
  position: fixed;
  width: 100%;
  top: 50px;
}
.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #677588;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}

.tab-tilte {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
}
.tab-tilte li {
  flex: 1;
}
.tab-tilte li span {
  padding: 10px;
  width: 100%;
  white-space: nowrap;
}
.exInput {
  box-sizing: border-box;
  padding: 0 15px;
  margin: 1px;
  width: 100%;
  height: 32px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
</style>
